<template>
  <a-drawer
      title="申请流程进度"
      placement="right"
      :width="550"
      :open="visible"
      @close="$emit('update:visible', false)"
  >
    <div v-if="record" class="progress-container">
      <h3 class="progress-title">申请编号：{{ record.applicationNo }}</h3>

      <div class="process-steps">
        <div
            v-for="(step, index) in processSteps"
            :key="index"
            :class="['process-step', { 'step-active': step.active, 'step-completed': step.completed }]"
        >
          <div class="step-content">
            <div class="step-header">
              <div v-if="step.nodeType === 'approval_node'" class="step-number">{{ step.completed ? step.result ? '✓' : 'x' : index + 1 }}</div>
              <div v-else class="step-number">{{ step.completed ? '✓' : index + 1 }}</div>
              <div class="step-info">
                <div class="step-title">{{ step.nodeName }}{{step.workday ? '（' + step.workday + '个工作日）' : ''}}</div>
                <div v-if="step.nodeType === 'start_node' || step.nodeType === 'end_node'">
                  <div class="step-time" v-if="step.startTime">{{ step.startTime }}</div>
                </div>
                <div v-else>
                  <div class="step-time" v-if="step.startTime">{{ step.startTime }} - {{ step.endTime ? step.endTime: ''}}</div>
                </div>
              </div>
            </div>

            <!-- 审批信息 -->
            <div v-if="step.approver" class="approval-info">
              <div class="approval-item">
                <span class="approval-label">审批人：</span>
                <span class="approval-content">{{ step.approver }}</span>
              </div>
              <div class="approval-item">
                <span class="approval-label">审批意见：</span>
                <span class="approval-content">{{ step.comment }}</span>
              </div>
            </div>

            <!-- 子节点 -->
            <div v-if="step.children && step.children.length > 0" class="sub-steps">
              <div
                  v-for="(child, childIndex) in step.children"
                  :key="childIndex"
                  :class="['sub-step', { 'sub-step-active': child.active , 'sub-step-completed': child.completed }]"
              >
                <div class="sub-step-content">
                  <div class="sub-step-number">{{ child.completed ? '✓' : '' }}</div>
                  <div class="sub-step-info">
                    <div class="sub-step-title">{{ child.nodeName }}{{child.workday ? '（' + child.workday + '个工作日）' : ''}}</div>
                    <div v-if="child.nodeType === 'start_node' || child.nodeType === 'end_node'">
                      <div class="step-time" v-if="child.startTime">{{ child.startTime }}</div>
                    </div>
                    <div v-else>
                      <div class="step-time" v-if="child.startTime">{{ child.startTime }} - {{ child.endTime ? child.endTime: ''}}</div>
                    </div>
                  </div>
                </div>

                <!-- 子节点审批信息 -->
<!--                <div v-if="child.approver" class="sub-approval-info">-->
<!--                  <div class="approval-item">-->
<!--                    <span class="approval-label">审批人：</span>-->
<!--                    <span class="approval-content">{{ child.approver }}</span>-->
<!--                  </div>-->
<!--                  <div class="approval-item">-->
<!--                    <span class="approval-label">审批意见：</span>-->
<!--                    <span class="approval-content">{{ child.comment }}</span>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>

          <!-- 连接线 -->
          <div v-if="index < processSteps.length - 1" class="step-connector"></div>
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue'
import { getProcessTasksByApplicationId } from '@/api/application/applicationProcessTask'
import {message} from "ant-design-vue";

// 组件属性
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  record: {
    type: Object,
    default: null
  }
})

const processSteps = ref([
  {
    id: 1,
    nodeType: 'start_node',
    nodeName: '已提交',
    workday: null,
    nextNodeId: '2',
    startTime: '2024-01-15 10:30:00',
    active: null,
    completed: 1, //0.待完成，1.已完成
    endTme: '2024-01-15 10:30:00', //完成时间
  },
  {
    id: 2,
    nodeType: 'approval_node',
    nodeName: '材料初审',
    workday: '5',
    nextNodeId: '3',
    startTime: '2024-01-15 10:30:00',
    active: null,
    completed: 1, //0.待完成，1.已完成
    endTme: '2024-01-16 10:30:00', //完成时间，
    comment: '审核备注',
    approver: '审核员A'
  },
  {
    id: 3,
    nodeType: 'activity_node',
    nodeName: '三方机构受理',
    workday: '25',
    nextNodeId: '6',
    startTime: null,
    active: 1,
    completed: 0, //0.待完成，1.已完成
    endTme: null, //完成时间
    children: [
      {
        id: 4,
        nodeType: 'activity_node',
        nodeName: '监管数据接入',
        workday: '5',
        nextNodeId: null,
        startTime: null,
        active: null,
        completed: 1, //0.待完成，1.已完成
        endTme: '2024-01-15 10:30:00', //完成时间
      },
      {
        id: 5,
        nodeType: 'activity_node',
        nodeName: '专家组评审',
        workday: '5',
        nextNodeId: null,
        startTime: null,
        active: 1,
        completed: 0, //0.待完成，1.已完成
        endTme: null, //完成时间
      },
    ]
  },
  {
    id: 6,
    nodeType: 'approval_node',
    nodeName: '联席工作小组审核',
    workday: '7',
    nextNodeId: null,
    startTime: null,
    active: null,
    completed: 0, //0.待完成，1.已完成
    endTme: null, //完成时间
  },
  {
    id: 7,
    nodeType: 'end_node',
    nodeName: '已通过',
    workday: null,
    nextNodeId: null,
    startTime: null,
    active: null,
    completed: 0, //0.待完成，1.已完成
    endTme: null, //完成时间
  },
])

// 监听弹框显示状态，仅在弹框打开且数据未加载过时加载数据
watch(() => props.visible, (newVisible) => {
  // 当弹框打开、有记录数据
  if (newVisible && props.record) {
    getProcessSteps();
  }
})

//获取流程步骤
function getProcessSteps() {

  getProcessTasksByApplicationId(props.record.id).then((res) => {
    processSteps.value = res.data || [];
  }).catch(error => {
    console.error('获取审批流程列表失败:', error);
    message.error('获取审批流程列表失败，请稍后重试');
  });
}

</script>

<style lang="less" scoped>
.progress-container {
  padding: 0 16px;
}

.progress-title {
  font-size: 16px;
  font-weight: 600;
  color: #0A212E;
  margin-bottom: 12px;
}

.progress-subtitle {
  font-size: 14px;
  color: #68767E;
  margin-bottom: 24px;
}

.process-steps {
  position: relative;
}

.process-step {
  position: relative;
  padding-left: 30px;
  margin-bottom: 20px;
}

.step-content {
  background: #F7F8FA;
  border-radius: 8px;
  padding: 10px;
  transition: all 0.3s;
}

.step-active .step-content {
  background: #E6F4FF;
  border: 1px solid #91D5FF;
}

.step-completed .step-content {
  background: #F6FFED;
  border: 1px solid #B7EB8F;
}

.step-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #D9D9D9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  margin-right: 12px;
  flex-shrink: 0;
}

.step-active .step-number {
  background: #1E8EF2;
}

.step-completed .step-number {
  background: #52C41A;
}

.step-info {
  flex: 1;
}

.step-title {
  font-size: 14px;
  font-weight: 600;
  color: #0A212E;
  margin-bottom: 4px;
}

.step-time {
  font-size: 13px;
  color: #68767E;
}

.approval-info {
  background: #fff;
  border-radius: 4px;
  padding: 12px;
  margin-top: 8px;
  border-left: 3px solid #1E8EF2;
}

.approval-item {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.approval-item:last-child {
  margin-bottom: 0;
}

.approval-label {
  font-weight: 500;
  color: #68767E;
  margin-right: 12px;
  min-width: 80px;
  text-align: right;
  flex-shrink: 0;
}

.approval-content {
  color: #0A212E;
  flex: 1;
  word-break: break-word;
}

/* 子步骤样式 */
.sub-steps {
  margin-top: 16px;
  padding-left: 36px;
}

.sub-step {
  margin-bottom: 16px;
}

.sub-step:last-child {
  margin-bottom: 0;
}

.sub-step-content {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.sub-step-number {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #D9D9D9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-right: 10px;
  flex-shrink: 0;
}

.sub-step-active .sub-step-number {
  background: #1E8EF2;
}

.sub-step-completed .sub-step-number {
  background: #52C41A;
}

.sub-step-info {
  flex: 1;
}

.sub-step-title {
  font-size: 13px;
  font-weight: 500;
  color: #0A212E;
  margin-bottom: 2px;
}

.sub-step-time {
  font-size: 11px;
  color: #68767E;
}

.sub-approval-info {
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  margin-top: 6px;
  border-left: 3px solid #722ED1;
}

/* 连接线样式 */
.step-connector {
  position: absolute;
  left: 12px;
  top: 56px;
  bottom: -20px;
  width: 2px;
  background: #D9D9D9;
}

.step-active .step-connector,
.step-completed .step-connector {
  background: #52C41A;
}
</style>